module.exports = __webpack_public_path__ + "img/lock2.76d6ff9c.svg";